import { IRescheduleAppointmentEligibilityResponse } from "@modules/eirCustomersFacade/interfaces/responses/IRescheduleAppointmentEligibilityResponse";
import { IRescheduleAppointmentEligibility } from "@modules/eirCustomersFacade/interfaces/models/IRescheduleAppointmentEligibility";

export const mapRescheduleAppointmentEligibility = (
    response: IRescheduleAppointmentEligibilityResponse
): IRescheduleAppointmentEligibility => ({
    isEligible: response.isEligible,
});
